import { render } from "./CollectionGroupEdit.vue?vue&type=template&id=bd220caa&scoped=true"
import script from "./CollectionGroupEdit.vue?vue&type=script&lang=js"
export * from "./CollectionGroupEdit.vue?vue&type=script&lang=js"

import "./CollectionGroupEdit.vue?vue&type=style&index=0&id=bd220caa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd220caa"]])

export default __exports__